
export const gameLetters = [
    ["L","W","L","M","O","E"],
    ["H", "G", "I","F","S","T"],
    ["I","M","S","L","S","E"],
    ["Y","C","O","R","N","A"],
    ["A","G","D","R","G","E"]
];